
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue'
import App from './components/App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import Snotify from 'vue-snotify'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTrash,
  faEdit,
  faPlus,
  faChild,
  faHome,
  faDollarSign,
  faCreditCard,
  faComment,
  faFileInvoice,
  faClock,
  faInfo,
  faCopy,
  faLink,
  faFileDownload,
  faSyncAlt,
  faEnvelope,
  faStar
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import store from './store/index'
import 'vue-md-icons/src/icons'
import Icon from 'vue-md-icons/src/components/Icon'
import VueBreadcrumbs from 'vue-2-breadcrumbs'
import fullscreen from 'vue-fullscreen'

import VueMoment from 'vue-moment'
import range from 'moment-range'
import api from '@api'
/* Mixins */

import Permissions from './mixins/Permissions'
import Global from './mixins/Global'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-snotify/styles/material.css'
import 'vue-select/dist/vue-select.css'

import events from '@utils/events'
import '@utils/filters'

Storage.prototype.setObject = function (key, value) {
  this.setItem(key, JSON.stringify(value))
}

Storage.prototype.getObject = function (key) {
  var value = this.getItem(key)
  return value && JSON.parse(value)
}

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueMoment, {
  range
})
Vue.use(VueBreadcrumbs, {
  template:
    '        <nav v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
    '            <ol class="breadcrumb">\n' +
    '                <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" class="breadcrumb-item active" aria-current="page">\n' +
    '                    <router-link :to="{ path: getPath(crumb) }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>' +
    '                </li>\n' +
    '            </ol>\n' +
    '        </nav>'
})

Vue.component('multiselect', Multiselect)
Vue.component('v-select', vSelect)
Vue.use(fullscreen)
Vue.mixin(Permissions)
Vue.mixin(Global)

Vue.use(BootstrapVue)
Vue.use(CKEditor)
Vue.use(Snotify)
library.add(
  faTrash,
  faEnvelope,
  faEdit,
  faPlus,
  faChild,
  faHome,
  faDollarSign,
  faCreditCard,
  faComment,
  faFileInvoice,
  faClock,
  faInfo,
  faCopy,
  faLink,
  faFileDownload,
  faStar,
  faSyncAlt
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('icon', Icon)

Vue.prototype.$api = api
Vue.prototype.$event = events

/**
* Next, we will create a fresh Vue application instance and attach it to
* the page. Then, you may begin adding components to this application
* or customize the JavaScript scaffolding to fit your unique needs.
*/

Vue.component('example-component', require('./components/App.vue'))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
